export enum ButtonsEnum {
  Hide,
  Show,
  ExpandScreen,
  SideBySide,
  SwitchScreen
}
